import { Box, Typography } from '@material-ui/core'
import { FC, memo } from 'react'

import Palette from '../palette'
import { useStyles } from './styles'

type LegendProps = {
  title: string
  values: {
    min: number
    max: number
  }
  colors: string[]
  unitOfMeasurement: string
}
const Legend: FC<LegendProps> = ({
  values,
  title,
  colors,
  unitOfMeasurement,
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Typography variant='h3'>Escala de {title.toLowerCase()}</Typography>

      <Palette
        colors={colors}
        unitOfMeasurement={unitOfMeasurement}
        values={values}
      />

      <Typography component='span'>
        * A escala indica o valor mínimo e máximo de leitura dos resultados.
      </Typography>
    </Box>
  )
}

export default memo(Legend)
